module.exports = __webpack_public_path__ + "media/images/ic-caixa-de-verdade-4953d59fa98b9ed7d37b9ed3d7faab04.svg";